import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Grid } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import Table from "../../components/Common/Table";
import TablePageControl from "../../components/Common/TablePageControl";
import CustomButton from "../../components/Form/CustomButton";
import { exportInventoryLog, getInventoryDetails, resetInventoryAttachmentState } from "../../store/inventory/actions";
import moment from "moment";
import Helpers from "../../helpers/helpers";
import CustomAutocomplete from "../../components/Form/CustomAutocomplete";

const ViewInventoryLog = ({ title, userPermission, inventoryDetails, approved_product, exportExcel }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const { ID } = useParams();

    const [loading, setIsLoading] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const [filterObject, setFilterObject] = useState({ platform: '', productType: '', status: '' });
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [name, setSearch] = useState("");
    const [sort, setSorted] = useState("asc");
    const [sort_by, setSortBy] = useState();
    const [currentID, setCurrentID] = useState(ID);
    const error = '';
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [exportable, setExportable] = useState(false);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("export-inventory") && setExportable(true);
            !userPermission?.includes("view-inventory") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(()=>{
        if(ID && !currentID){
            setCurrentID(ID);
        }
    }, [ID])

    useEffect(() => {
        setIsLoading(true);
        const payload = {
            id: currentID,
            page: page,
            size: length,
        }
        dispatch(getInventoryDetails(payload))
        setIsLoading(false);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, length, currentID]);


    const header = [
        {
            Header: "Log ID",
            accessor: (cellProps, idx) => {
                return (
                    <React.Fragment>
                        {cellProps?.id}
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Action Type",
            accessor: (cellProps) => {
                return (
                    <div className="d-flex align-items-center">
                        <div>{cellProps?.type && Helpers?.capitalizeWords((cellProps?.type).replace(/_/g, " "))}</div>
                    </div>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Balance update",
            accessor: (cellProps) => {
                return (<>{cellProps?.old_balance || '-'}<i className="ri-arrow-right-line mx-2" />{cellProps?.balance || '-'}</>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Low stock threshold",
            accessor: (cellProps) => {
                return (<>{cellProps?.old_low_stock_threshold || '-'}<i className="ri-arrow-right-line mx-2" />{cellProps?.low_stock_threshold || '-'}</>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Date/Time",
            accessor: (cellProps) => {
                return (
                    <>
                        {moment(cellProps?.created_date).format("DD MMM YYYY") || '-'} <br />
                        <span style={{ color: "#A0A0A0" }}>{moment(cellProps?.created_date).format("hh:mm A") || '-'}</span>
                    </>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "User",
            accessor: (cellProps, idx) => {
                return (<>{cellProps?.updated_by || '-'}</>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Comments",
            accessor: (cellProps, idx) => {
                return (<div>{cellProps?.comments || '-'}</div>)
            },
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Notification triggered",
            accessor: (cellProps) => {
                return (cellProps?.notified)
            },
            disableFilters: true,
            filterable: false,
        }
    ]

    const resetFilter = () => {
        setCurrentID(ID);
    }

    const handleExport = () => {
        setIsLoading(true);
        dispatch(exportInventoryLog(parseInt(currentID)));
    }

    useEffect(() => {
        if (exportExcel?.code === "success") {
            setIsLoading(false)
            Helpers.handleDownloadExcelFile(exportExcel?.excel_base64, 'Inventory Log');
            dispatch(resetInventoryAttachmentState());
        }

    }, [exportExcel]);

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={1} paddingBlock={1}>
                <Grid container item lg={10} md={12} spacing={1} className="d-flex align-items-center">
                    <Grid item lg={6} md={6} xs={12}>
                        <CustomAutocomplete
                            style={{
                                color: parseInt(currentID) === "" && "#c8c8c8",
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "50px",
                                },
                                backgroundColor: "white",
                                borderRadius: "100px"
                            }}
                            labelName={"name"}
                            valueName={"id"}
                            freeSolo={true}
                            values={parseInt(currentID)}
                            // values={parseInt(ID)}
                            onChange={(e, value) => {
                                // if (value?.id) navigate(`/inventory/${value?.id}`)
                                // else
                                //     navigate(`/inventory/${ID}`)
                                setPage("1");
                                setCurrentID(value?.id)
                            }}
                            data={approved_product}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} xs={12}>
                        <CustomButton
                            title={'Clear'}
                            press={() => resetFilter()}
                            height={32}
                            backgroundColor={'transparent'}
                            textColor={'#7BB9FA'}
                        />
                    </Grid>
                </Grid>

                <Grid item lg={2} md={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'start' }, marginInline: { lg: 0, md: 1 } }} alignItems={'center'}>
                    {exportable && <CustomButton
                        title={<><i className="ri-download-2-line" style={{ marginRight: 5 }} />Export</>}
                        press={() => handleExport()}
                        height={32}
                        borderRadius={15}
                        borderStyle={"1px solid #babcbe"}
                    />}
                </Grid>

            </Grid>
        )
    }

    const renderHeader = () => {
        return (
            <Breadcrumbs
                backRoute={"/inventory"}
                breadcrumbItems={[{ title: "Inventories", link: "/inventory" },
                { title: title, link: "#" },
                ]}
            />
        )
    }
    
    return (
        <React.Fragment>
            <div className="page-content">
                <LoadingDialog open={loading || !inventoryDetails?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    {renderHeader()}
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={inventoryDetails?.data || []}
                        pageSize={length}
                        totalPage={inventoryDetails?.last_page}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                        setCheckedAll={setCheckedAll}
                        checkedAll={checkedAll}
                    />
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={inventoryDetails?.last_page}
                    />
                </Container>
            </div>
        </React.Fragment>
    );
};

function mapStateToProps({ Login, Inventory, General }) {
    return {
        userPermission: Login.permissionArry,
        inventoryDetails: Inventory.inventoryDetails,
        approved_product: General.approved_products,
        exportExcel: Inventory.exportInventoryLog,

    };
}

export default connect(mapStateToProps)(ViewInventoryLog);
